import { useState, useEffect } from "react";
import "./ResponseContentWebsite.css";
import { Question } from "effno-core";
import { ResponseNavigate } from "./ResponseNavigate";
import { validateURL } from "../shared/responseValidators";
import config from "environment";
import { ResponseErrors } from "./responseErrors";
import { set } from "react-datepicker/dist/date_utils";
import { NEXT_BUTTON } from "./ResponseContent";
import { TriangleAlert } from "lucide-react";

const debugMode = config.debugMode;

type ResponseContentWebsiteProps = {
    question: Question;
    responseValues: string;
    isPreview: boolean;
    isMobileLayout: boolean;
    isLastQuestion: boolean;
    commentMode: boolean;
    onNext?: () => void;
    onPrev?: () => void;
    onSubmit: (responseValues: string) => void;
}

export const ResponseContentWebsite = ({
    question,
    responseValues,
    isPreview,
    isMobileLayout,
    isLastQuestion,
    commentMode,
    onNext,
    onPrev,
    onSubmit
} : ResponseContentWebsiteProps) => {

    const [title, setTitle] = useState<string>("");
    const [description, setDescription] = useState<string>("");
    const [URL, setURL] = useState<string>("");
    const [error, setError] = useState<string>("");

    useEffect(() => {
        setTitle(question.title);
        setDescription(question.description);
        setURL(JSON.parse(responseValues).URL || "");
        setError(ResponseErrors.none);
    }, [question, responseValues])

    const metRequirements = (theURL: string) : "ok" | "required" | "invalid" => {

        if (theURL.trim() !== "") {
            const validURL = validateURL(theURL);

            if (!validURL) {
                return "invalid";
            }

            return "ok";
        }

        if (!question.required) {
            return "ok";
        }

        if (question.required && theURL.trim() === "") {
            return "required";
        }

        return "invalid";
    }

    const handleNext = () => {
        if (isPreview && onNext) {
            onNext();
        } else {
            handleSubmit();
        }
    }

    const handleSubmit = () => {

        const met = metRequirements(URL);

        if (met === "required") {
            setError(ResponseErrors.required);
            return;
        }

        if (met === "invalid") {
            setError(ResponseErrors.validURL);
            return;
        }

        setError(ResponseErrors.none);

        const newResponseValues: string = JSON.stringify({
            URL
        });

        onSubmit(newResponseValues);
    }

    const handleKeyDown = (e: any) => {
        if (e.key === "Enter") {
            handleSubmit();
            return;
        }

        setError(ResponseErrors.none);
    
    }

    const handlePaste = (e: any) => {
        const theURL = e.clipboardData.getData('text');

        const metReqs = metRequirements(theURL);
    
        if (metReqs === "invalid") {
            setError(ResponseErrors.validURL);
            return;
        }
    }

    const handleChange = (e: any) => {
        setURL(e.target.value);
    }

    const requirementsMet = metRequirements(URL) === "ok";
    
    // console.log("[ResponseContentWebsite] question: ", question);
    // console.log("[ResponseContentWebsite] values: ", responseValues);
    // console.log("[ResponseContentWebsite] URL: ", URL);
    // console.log("[ResponseContentWebsite] requirementsMet: ", requirementsMet);


    return (
        <div className="form-content-body">

            {/* {debugMode && question &&
                <div className="response-content-question-id">
                    {question.id}
                </div>
            } */}
            
            <div 
                className="response-content-title"
                data-testid={"response-content-title:" + title}
            >
                {title}
            </div>
            
            <div className="response-content-description">
               {description}
            </div>   

            <div style={{marginTop: "24px"}} className="response-content-text">
                <input 
                    type="text"
                    onChange={handleChange}
                    onKeyDown={handleKeyDown}
                    onPaste={handlePaste}
                    value={URL}
                    placeholder="website.com"
                    data-testid="response-content-value"
                    autoFocus={true}
                />
            </div>   

            <div 
                className="response-content-error"
                style={!error ? {backgroundColor: "transparent"} : {}}
                data-testid="response-content-error"
            >
                {error && <TriangleAlert size={16}/>}{error}
            </div>

            {/* <div className="response-content-submit">
                <button
                    className="response-content-button-submit"
                    onClick={handleSubmit}
                    data-testid="response-content-submit"
                >
                    {onNext ? NEXT_BUTTON : "Submit"}
                </button>
            </div> */}

            <ResponseNavigate 
                isMobileLayout={isMobileLayout}
                isLastQuestion={isLastQuestion}
                commentMode={commentMode}
                allowEnter={true}
                onSubmit={handleSubmit}
                onNext={handleNext}
                onPrev={onPrev}
            />

        </div>
    )
}